import { jsxs as i, jsx as l } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#star-filled_svg__a)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "m8.25 7.841-6.38.925-.112.023a1 1 0 0 0-.44 1.684l4.622 4.5-1.09 6.354-.013.11a1 1 0 0 0 1.464.944l5.706-3 5.693 3 .1.046a.999.999 0 0 0 1.352-1.1l-1.091-6.355 4.624-4.5.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926-2.852-5.78a1 1 0 0 0-1.794 0z"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "star-filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  t as default
};
